<!-- A section of the PO item card, not a card of its own: cards don't nest. The tuning fields sit
     in a collapsed "Advanced watermark" block, the same split the template settings form makes. -->
<ng-container [formGroup]="form">
  <h3 class="cl-spacing-medium">Watermark</h3>
  <p>Every delivery of this type carries a Castlabs Single Frame Watermark. Codec, container and
    resolution are taken from the source and passed through unchanged; only the video essence is
    re-encoded to carry the mark.</p>

  <div class="row">
    <div class="col-12 col-md-6">
      <label class="form-label" [for]="idPrefix + 'sd_wm_id'">ID<span class="required">*</span></label>
      <input class="form-control" [class.invalid]="form.get('sd_wm_id').invalid && (form.get('sd_wm_id').touched || submitted)" formControlName="sd_wm_id"
             [id]="idPrefix + 'sd_wm_id'" type="number">
      @if (form.get('sd_wm_id').errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (form.get('sd_wm_id').errors?.max) {
        <p class="invalid-feedback">The maximum value is {{ form.get('sd_wm_id').errors.max.max }}.</p>
      }
      @if (form.get('sd_wm_id').errors?.min) {
        <p class="invalid-feedback">Negative values are not permitted.</p>
      }
      @if (!form.get('sd_wm_id').errors) {
        <p class="valid-feedback">Identifies the recipient this copy is traced back to.</p>
      }
    </div>
    <div class="col-12 col-md-6">
      <label class="form-label" [for]="idPrefix + 'sd_strength'">Strength<span class="required">*</span></label>
      <input class="form-control" [class.invalid]="form.get('sd_strength').invalid && (form.get('sd_strength').touched || submitted)" formControlName="sd_strength"
             [id]="idPrefix + 'sd_strength'" max="20" min="1" step="1" type="number"/>
      @if (form.get('sd_strength').errors?.required) {
        <p class="invalid-feedback">This field is required.</p>
      }
      @if (form.get('sd_strength').errors?.max) {
        <p class="invalid-feedback">The maximum value is {{ form.get('sd_strength').errors.max.max }}.</p>
      }
      @if (form.get('sd_strength').errors?.min) {
        <p class="invalid-feedback">The minimum value is {{ form.get('sd_strength').errors.min.min }}.</p>
      }
      @if (!form.get('sd_strength').errors) {
        <p class="valid-feedback">The default value is 4 (standard robustness).</p>
      }
    </div>
  </div>

  <details class="cl-spacing-small" data-advanced>
    <summary>Advanced watermark</summary>
    <div class="row">
      <div class="col-12 col-md-6">
        <label class="form-label" [for]="idPrefix + 'sd_bit_profile'">Bit profile</label>
        <select class="form-select" formControlName="sd_bit_profile" [id]="idPrefix + 'sd_bit_profile'">
          @for (p of sd_bit_profiles; track p) {
            <option [ngValue]="p.id">{{ p.name }}</option>
          }
        </select>
        <p class="valid-feedback">Sets how many distinct watermarks exist, and the highest usable ID.</p>
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label" [for]="idPrefix + 'sd_pm_mode'">Perceptual masking</label>
        <select class="form-select" formControlName="sd_pm_mode" [id]="idPrefix + 'sd_pm_mode'">
          @for (m of sd_pm_modes; track m) {
            <option [ngValue]="m.id">{{ m.name }}</option>
          }
        </select>
        <p class="valid-feedback valid-feedback-none"></p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <label class="form-label" [for]="idPrefix + 'sd_superpixel_density'">Superpixel density</label>
        <select class="form-select" formControlName="sd_superpixel_density" [id]="idPrefix + 'sd_superpixel_density'">
          @for (d of densities; track d) {
            <option [ngValue]="d.id">{{ d.name }}</option>
          }
        </select>
        <p class="valid-feedback valid-feedback-none"></p>
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label" [for]="idPrefix + 'sd_pixel_density'">Pixel density</label>
        <select class="form-select" formControlName="sd_pixel_density" [id]="idPrefix + 'sd_pixel_density'">
          @for (d of densities; track d) {
            <option [ngValue]="d.id">{{ d.name }}</option>
          }
        </select>
        <p class="valid-feedback valid-feedback-none"></p>
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label" [for]="idPrefix + 'sd_seed'">Seed</label>
        <input class="form-control" [class.invalid]="form.get('sd_seed').invalid && (form.get('sd_seed').touched || submitted)" formControlName="sd_seed"
               [id]="idPrefix + 'sd_seed'" max="31" min="-1" step="1" type="number"/>
        @if (form.get('sd_seed').errors) {
          <p class="invalid-feedback">Use -1 for automatic, or a value from 0 to 31.</p>
        } @else {
          <p class="valid-feedback">-1 picks a seed per job.</p>
        }
      </div>
    </div>
  </details>

</ng-container>
